// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import ManualAutomations from './data'

export default function ManualAutomationsFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/ManualAutomations">
      <ManualAutomations {...props}>
        {children}
      </ManualAutomations>
    </Flow>
  )
}
